export enum AccountProfileFeature {
  EnableAdUnitDebugging = 'EnableAdUnitDebugging',
  EnablePassedUrls = 'EnablePassedUrls',
  EnablePassedKeywords = 'EnablePassedKeywords',
  EnableCrawling = 'EnableCrawling',
  EnableGlobalDefaultKeywords = 'EnableGlobalDefaultKeywords',
  EnableAdultAds = 'EnableAdultAds'
}
